import Error from '../../../model/Error.js';
import OfferingBooking from '../../../dto/offering/OfferingBooking.js';
import axios from 'axios';
import moment from 'moment';

export default class OfferingBookingRepository {
    static findAll(appointmentId, startDate, startTime) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/offering-bookings/appointment-series/${appointmentId}/${startDate}/${startTime}`)
                .then((response) => resolve(response.data.data.map((data) => OfferingBooking.fromData(data))))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static cancel(bookingId, inform) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/club/offering-bookings/${bookingId}/cancel`, {
                    informParticipantByEmail: inform,
                })
                .then((response) => resolve(response.data.data))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static addParticipant(clubId, memberId, appointment, clubExamIds = null, selectedSalesListOfferingItems = []) {
        return new Promise((resolve, reject) => {
            const data = {
                appointmentSeriesId: appointment.appointmentSeries.id,
                start: moment(appointment.start.date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm'),
                memberId,
                invoiceMemberId: memberId,
                selectedSalesListOfferingItems,
            };
            if (clubExamIds) {
                data.clubExamIds = clubExamIds;
            }
            axios
                .post(`/club/clubs/${clubId}/offering-bookings`, data)
                .then((response) => resolve(response.data.data))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static addDogAndParticipant(clubId, params, appointment, selectedSalesListOfferingItems = []) {
        return new Promise((resolve, reject) => {
            axios
                .post(`/club/clubs/${clubId}/offering-bookings`, {
                    appointmentSeriesId: appointment.appointmentSeries.id,
                    start: moment(appointment.start.date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm'),
                    dogId: params.dogId,
                    memberId: params.memberId,
                    invoiceMemberId: params.memberId,
                    clubExamIds: params.selectedExams,
                    selectedSalesListOfferingItems,
                })
                .then((response) => resolve(response.data.data))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static addParticipantToOffering(clubId, offeringId, params, selectedSalesListOfferingItems = []) {
        const data = {
            offeringId,
            memberId: params.id,
            selectedSalesListOfferingItems,
        };
        if (params.selectedExams) {
            data.clubExamIds = params.selectedExams;
        }
        return new Promise((resolve, reject) => {
            axios
                .post(`/club/clubs/${clubId}/offering-bookings/all`, data)
                .then((response) => resolve(response.data.data))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static addDogAndParticipantToOffering(clubId, offeringId, params, selectedSalesListOfferingItems = []) {
        return new Promise((resolve, reject) => {
            axios
                .post(`/club/clubs/${clubId}/offering-bookings/all`, {
                    offeringId,
                    dogId: params.dogId,
                    memberId: params.memberId,
                    clubExamIds: params.selectedExams,
                    selectedSalesListOfferingItems,
                })
                .then((response) => resolve(response.data.data))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static update(offeringBookingId, bookedSalesListOfferingItems) {
        const data = { bookedSalesListOfferingItems };
        return new Promise((resolve, reject) => {
            axios
                .put(`/club/offering-bookings/${offeringBookingId}`, data)
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
